import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateExternalToolCategoryDto } from '@inference.engine/api-client/web';
import { notificationService } from '@/lib/services/notification.service';
import { i18n } from '@/shared/i18n';
import { logger } from '@/lib/utils/logger';
import { createExternalToolCategory } from '../api';
import { EXTERNAL_TOOL_CATEGORIES_QUERY_KEY } from './queryKeys';

export const useCreateExternalToolCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      body,
      workspaceId,
    }: {
      body: CreateExternalToolCategoryDto;
      workspaceId?: string;
    }) => createExternalToolCategory(body, workspaceId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [EXTERNAL_TOOL_CATEGORIES_QUERY_KEY] });
      notificationService.showSuccess(
        i18n.t('admin:externalTool.useCreateExternalToolCategory.categoryCreated'),
      );
    },
    onError: (error) => {
      notificationService.showError(
        i18n.t('admin:externalTool.useCreateExternalToolCategory.failedToCreateCategory'),
      );
      logger.error('Failed to create category:', error);
    },
  });
};
